import { IPaymentMethodConfig, IDecardPaymentConfig } from "@finbackoffice/clientbff-client";
import { DecardPaymentMethod, PaymentProvider } from "@finbackoffice/enums";

export const ALLOWED_CARD_BRANDS = ["visa", "mastercard"];

export type MultiWalletViewType = "deposit" | "withdraw";

export type MultiWalletPaymentMethod = Partial<IPaymentMethodConfig> & {
    name: DecardPaymentMethod;
    provider: PaymentProvider;
};

export const convertProviderConfig = (
    config: IDecardPaymentConfig,
    provider: PaymentProvider,
): MultiWalletPaymentMethod[] => {
    let result = [];

    result = Object.keys(config).map((method) => {
        return {
            ...config[method as DecardPaymentMethod],
            name: method as DecardPaymentMethod,
            provider: provider,
        };
    });

    return result.filter((config) => config.enabled);
};
